export default "<a [href]=\"pdfUrl\" target=\"_blank\">Pdf Note Link</a>\n"